const ADD_PRODUCTION_LINES = "ADD_PRODUCTION_LINES";
const ADD_WORK_ORDERS = "ADD_WORK_ORDERS";
const WORK_ORDERS_UPDATED = "WORK_ORDERS_UPDATED";
const WORK_ORDER_UPDATED = "WORK_ORDER_UPDATED";
const ADD_WORK_ORDER_COMMENT = "ADD_WORK_ORDER_COMMENT";
const ADD_NOTIFICATION = "ADD_NOTIFICATION";
const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
const SET_LAST_CLEANINGS = "SET_LAST_CLEANINGS";
const ADD_LAST_CLEANING = "ADD_LAST_CLEANING";

export { ADD_PRODUCTION_LINES };
export { ADD_WORK_ORDERS };
export { WORK_ORDERS_UPDATED };
export { WORK_ORDER_UPDATED };
export { ADD_WORK_ORDER_COMMENT };
export { ADD_NOTIFICATION };
export { DELETE_NOTIFICATION };
export { SET_LAST_CLEANINGS };
export { ADD_LAST_CLEANING };
